import { PlusIcon } from "@heroicons/react/16/solid";
import {
  SidebarItem,
  SidebarLabel,
  SidebarSection,
  SidebarSpacer,
} from "../../../design/sidebar";
import { useMatter } from "../../../contexts/MatterContext";
import { useLocation } from "react-router-dom";
import {
  ArchiveBoxIcon,
  BanknotesIcon,
  BriefcaseIcon,
  BuildingOffice2Icon,
  ChatBubbleLeftIcon,
  ClipboardDocumentListIcon,
  ClockIcon,
  DocumentCurrencyDollarIcon,
  DocumentTextIcon,
  FolderIcon,
  HomeIcon,
  LifebuoyIcon,
  LockOpenIcon,
  QuestionMarkCircleIcon,
  StarIcon,
  UserCircleIcon,
  UserGroupIcon,
  UsersIcon,
} from "@heroicons/react/20/solid";
import { Badge } from "../../../design/badge";
import { useTask } from "../../../contexts/TaskContext";

const AdminSidebar = () => {
  const location = useLocation();
  const { taskCounts } = useTask();
  const { matters, currentMatterId, currentMatter } = useMatter();
  return (
    <>
      <SidebarSection>
        <SidebarItem href="/dashboard" id="dashboard-sidebar-item">
          <HomeIcon />
          <SidebarLabel>Dashboard</SidebarLabel>
        </SidebarItem>
        <SidebarItem href="/matter-types">
          <FolderIcon />
          <SidebarLabel>Matter Types</SidebarLabel>
        </SidebarItem>
        <SidebarItem href="/event-categories">
          <FolderIcon />
          <SidebarLabel>Event Categories</SidebarLabel>
        </SidebarItem>
        <SidebarItem href="/users">
          <UsersIcon />
          <SidebarLabel>Users</SidebarLabel>
        </SidebarItem>
        <SidebarItem href="/intakes">
          <ClipboardDocumentListIcon />
          <SidebarLabel>Intakes</SidebarLabel>
        </SidebarItem>
        <SidebarItem href="/matters">
          <BriefcaseIcon />
          <SidebarLabel>Matters</SidebarLabel>
        </SidebarItem>
        <SidebarItem href="/holidays">
          <StarIcon />
          <SidebarLabel>Holidays</SidebarLabel>
        </SidebarItem>
        <SidebarItem
          href="/conversations"
          id="conversations-sidebar-item"
          current={location.pathname === "/conversations"}
        >
          <ChatBubbleLeftIcon />
          <SidebarLabel>Conversations</SidebarLabel>
        </SidebarItem>
      </SidebarSection>
      <SidebarSpacer />
      <SidebarSection>
        <SidebarItem href="/settings">
          <UserCircleIcon />
          <SidebarLabel>Settings</SidebarLabel>
        </SidebarItem>
      </SidebarSection>
    </>
  );
};

export default AdminSidebar;
